import React, { Component } from 'react';

export class NoNotifications extends Component {
  public render() {
    return (
      <div className="c-notification-center__empty-wrapper">
        <div className="c-notification-center__empty">
          <div className="c-notification-center__empty-bell" />
          <div className="c-notification-center__empty-content">
            <h4 className="c-notification-center__empty-header">Еще нет уведомлений</h4>
            <p className="c-notification-center__empty-text">
              Здесь будут уведомления об изменении цены, новых объявлениях по вашему поиску
            </p>
          </div>
        </div>
      </div>
    );
  }
}
